import React, { createContext, useContext, useState, useEffect } from 'react';
import { getSessionData } from './auth';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {

    const loggedInUser = getSessionData();

    const [isAuthenticated, setIsAuthenticated] = useState(loggedInUser !== null);
    const [role, setRole] = useState(loggedInUser?.role || null);
    const [user, setUser] = useState(loggedInUser || null);


    const logon = () => {
        const userObj = getSessionData();
        if (userObj) {
            setUser(userObj);
            setRole(userObj?.role || "");
            setIsAuthenticated(true); 
        }
    };

    const logoff = () => {
        // console.log("setIsAuthenticated logoff");
        setIsAuthenticated(false);
        setRole(null);
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, logon, logoff, role }}>
            {children}
        </AuthContext.Provider>
    );
};